module.exports = __webpack_public_path__ + "img/battery-three-quarters.aab3f2e5.svg";